module.exports = __webpack_public_path__ + "static/img/thumb_11.09283ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_11.png
// module id = kxF9
// module chunks = 0